// extracted by mini-css-extract-plugin
module.exports = {"modal":"AdMaterialEditor_modal__1NpVh","buttons":"AdMaterialEditor_buttons__3qihp"};